import { Box, Typography, Button } from '@mui/material';
import { Selector } from 'components/Form/Selectors/Selector';
import { ThemePalette } from 'mui.theme';
import { type Asset } from 'types/asset.types';
import { useTranslation } from 'react-i18next';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

export const AssetSelector = ({
  enableDarkTheme,
  makeModels,
  selectedMakeModel,
  setSelectedMakeModel,
  assetBumperIds,
  selectedAsset,
  setSelectedAsset,
  comparingAsset,
  setComparingAsset,
}: {
  enableDarkTheme: boolean;
  makeModels: string[];
  selectedMakeModel: string;
  setSelectedMakeModel: any;
  assetBumperIds: string[];
  selectedAsset: Asset;
  setSelectedAsset: any;
  comparingAsset: string;
  setComparingAsset: any;
}) => {
  const palette = enableDarkTheme
    ? clientThemePalette[CLIENT_THEME].dark
    : clientThemePalette[CLIENT_THEME].light;
  const { t } = useTranslation();
  const makeModelList = makeModels.map((item) => {
    return {
      id: item,
      display: item,
    };
  });

  const assetList = assetBumperIds.map((item) => {
    return {
      id: item,
      display: item,
    };
  });

  return (
    <>
      {/* Make Model */}
      <Box
        sx={{
          paddingTop: '10px',
          paddingLeft: '10px',
          paddingRight: '10px',
        }}
      >
        <Typography
          variant="bodyBold"
          display="block"
          mb={'4px'}
          sx={{
            paddingBottom: '10px',
            color: palette.textPrimary,
          }}
        >
          {t('make_model')}
        </Typography>
        <Selector
          minWidth="200px"
          value={selectedMakeModel}
          onChange={(event) => {
            setSelectedMakeModel(String(event.target.value));
          }}
          selectorOptions={makeModelList}
          enableDarkTheme={enableDarkTheme}
        />
      </Box>
      {/* BUmper ID */}
      <Box
        sx={{
          paddingTop: '10px',
          paddingRight: '10px',
        }}
      >
        <Typography
          variant="bodyBold"
          display="block"
          mb={'4px'}
          sx={{
            paddingBottom: '10px',
            color: palette.textPrimary,
          }}
        >
          {t('bumper_id_11')}
        </Typography>
        <Selector
          minWidth="200px"
          value={selectedAsset.bumperNumber}
          onChange={(event) => {
            setSelectedAsset(String(event.target.value));
          }}
          selectorOptions={assetList.filter(
            (item) => item.id !== comparingAsset
          )}
          enableDarkTheme={enableDarkTheme}
        />
      </Box>

      {/* Compare to */}
      <Box
        sx={{
          paddingTop: '10px',
          paddingRight: '10px',
          marginLeft: '20px',
        }}
      >
        <Typography
          variant="bodyBold"
          display="block"
          mb={'4px'}
          sx={{
            paddingBottom: '10px',
            color: palette.textPrimary,
          }}
        >
          {t('compare_to')}
        </Typography>
        <Selector
          minWidth="200px"
          value={comparingAsset}
          onChange={(event) => {
            setComparingAsset(String(event.target.value));
          }}
          selectorOptions={assetList.filter(
            (item) => item.id !== selectedAsset.bumperNumber
          )}
          enableDarkTheme={enableDarkTheme}
        />
      </Box>

      {comparingAsset !== '' && (
        <Box
          sx={{
            alignContent: 'center',
            marginLeft: '20px',
            marginTop: '30px',
          }}
        >
          <Button
            sx={{
              backgroundColor: palette.primary,
              color: ThemePalette.typography.white,
              textTransform: 'none',
              height: '40px',
              paddingLeft: '15px',
              paddingRight: '15px',
              fontSize: '12px',
              border: `1px solid white`,
              '&:hover': {
                color: enableDarkTheme ? 'white' : 'black',
                border: enableDarkTheme ? '1px solid white' : '1px solid black',
              },
            }}
            onClick={() => {
              setComparingAsset('');
            }}
          >
            {t('reset_comparison')}
          </Button>
        </Box>
      )}
    </>
  );
};
